import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { getEstados } from '../../actions/estados'
import { getLOVExpediente, nuevoExpediente } from '../../actions/expedientes'
import { createMessage } from '../../actions/messages'
import { getProvincias } from '../../actions/provincias'
import '../../css/AltaCliente.css'
import i18n from '../../lang/idiomas'
import Spinner from '../layout/Spinner'

const AltaCliente = () => {
  const dispatch = useDispatch()

  const isLoading = useSelector(state => state.expedientes.isLoading)
  const estados = useSelector(state => state.estados.estados)
  const provincias = useSelector(state => state.provincias.provincias)
  const lovs = useSelector(state => state.expedientes.valores_lovs)

  const [valores, setValores] = useState({
    tipo_empresa: '',
    canti_empresa: '',
    razon_social: '',
    nif: '',
    contacto_empresa: '',
    subir: '',
    direccion: '',
    poblacion: '',
    codigo_postal: '',
    provincia: '',
    pais: '',
    usar_dir_fiscal: false,
    direccion_envio: '',
    poblacion_envio: '',
    codigo_postal_envio: '',
    provincia_envio: '',
    pais_envio: '',
    horario_entrega: '',
    contacto: '',
    contacto2: '',
    telefono: '',
    telefono2: '',
    movil: '',
    movil2: '',
    email1: '',
    email2: '',
    email_facturas: '',
    web: '',
    banco: '',
    forma_pago_general: '',
    forma_pago: '',
    iban: 'ES',
    num1: '',
    num2: '',
    num3: '',
    num4: '',
    num5: '',
    contrareembolso: 'S',
    recargo: '',
    observaciones: '',
    cargo1: '',
    cargo2: '',
    promotions: false,
    idioma_cliente: '',
  })
  const [optionsProvincias, setOptionsProvincias] = useState([])
  const [optionsProvinciasEnvio, setOptionsProvinciasEnvio] = useState([])
  const [backupDirEnvio, setBackupDirEnvio] = useState([])

  const optionsTipoEmpresa = [
    { value: 'MA', label: i18n.t('general.mayoris'), name: 'tipo_empresa' },
    { value: 'MI', label: i18n.t('altaCliente.optsemp2'), name: 'tipo_empresa' },
    { value: 'PO', label: i18n.t('altaCliente.optsemp3'), name: 'tipo_empresa' },
    { value: 'OT', label: i18n.t('general.otros'), name: 'tipo_empresa' },
  ]

  const optionsCantiEmpresa = [
    { value: '001', label: '1-3', name: 'canti_empresa' },
    { value: '002', label: '4-6', name: 'canti_empresa' },
    { value: '003', label: '7-10', name: 'canti_empresa' },
    { value: '004', label: '+10', name: 'canti_empresa' },
  ]

  const optionsCargo = [
    { value: 'ADMIN', label: i18n.t('altaCliente.optscrg3'), name: 'cargo' },
    { value: 'ALMACEN', label: i18n.t('altaCliente.optscrg5'), name: 'cargo' },
    { value: 'COMERCIAL', label: i18n.t('altaCliente.optscrg6'), name: 'cargo' },
    { value: 'COMPRAS', label: i18n.t('general.compras'), name: 'cargo' },
    { value: 'CONTA', label: i18n.t('altaCliente.optscrg2'), name: 'cargo' },
    { value: 'MARKETING', label: i18n.t('altaCliente.optscrg4'), name: 'cargo' },
    { value: 'OTROS', label: i18n.t('altaCliente.optscrg1'), name: 'cargo' },
  ]

  const optionsEstados = estados.map(estado => ({
    value: estado.codigo,
    label: estado.nombre,
  }))

  const optionsIdiomas = lovs[0]?.data.map(({ value, label }) => ({
    value,
    label,
  }))

  useEffect(() => {
    if (!estados.length) {
      dispatch(getEstados())
    }
    if (!lovs.length) {
      dispatch(
        getLOVExpediente(
          'ALTA_CLIENTE',
          'CRMFAMILIAS_LIN_X_4',
          'CODIGO_ESTAD4',
        ),
      )
    }
  }, [])

  useEffect(() => {
    if (valores.pais) {
      dispatch(getProvincias(valores.pais))
    }
  }, [valores.pais])

  useEffect(() => {
    if (valores.pais_envio && !valores.usar_dir_fiscal) {
      dispatch(getProvincias(valores.pais_envio))
    }
  }, [valores.pais_envio])

  useEffect(() => {
    if (provincias[0]?.estado !== valores.pais) return
    setOptionsProvincias(
      provincias.map(provincia => ({
        value: provincia.provincia,
        label: provincia.nombre,
        estado: provincia.estado,
      })),
    )
  }, [provincias])

  useEffect(() => {
    if (provincias[0]?.estado !== valores.pais_envio) return
    setOptionsProvinciasEnvio(
      provincias.map(provincia => ({
        value: provincia.provincia,
        label: provincia.nombre,
        estado: provincia.estado,
      })),
    )
  }, [provincias])

  useEffect(() => {
    if (valores.usar_dir_fiscal) return
    if (optionsProvincias.length === 1) {
      setValores(prev => ({
        ...prev,
        ['provincia']: optionsProvincias[0].value,
      }))
    } else {
      setValores(prev => ({
        ...prev,
        ['provincia']: '',
      }))
    }
  }, [optionsProvincias, valores.usar_dir_fiscal])

  useEffect(() => {
    if (valores.usar_dir_fiscal) return
    if (optionsProvinciasEnvio.length === 1) {
      setValores({ ...valores, ['provincia_envio']: optionsProvinciasEnvio[0].value })
    } else {
      setValores({ ...valores, ['provincia_envio']: '' })
    }
  }, [optionsProvinciasEnvio, valores.usar_dir_fiscal])

  useEffect(() => {
    if (valores.usar_dir_fiscal) {
      setBackupDirEnvio({
        ['direccion_envio']: valores.direccion_envio,
        ['pais_envio']: valores.pais_envio,
        ['provincia_envio']: valores.provincia_envio,
        ['poblacion_envio']: valores.poblacion_envio,
        ['codigo_postal_envio']: valores.codigo_postal_envio,
      })
      setValores(prev => ({
        ...prev,
        ['direccion_envio']: valores.direccion,
        ['pais_envio']: valores.pais,
        ['provincia_envio']: valores.provincia,
        ['poblacion_envio']: valores.poblacion,
        ['codigo_postal_envio']: valores.codigo_postal,
      }))
    } else if (backupDirEnvio) {
      setValores(prev => ({
        ...prev,
        ...backupDirEnvio,
      }))
    }
  }, [valores.usar_dir_fiscal])

  const [files, setFiles] = useState({
    filesAux: [],
    fileInput: React.createRef(),
  })

  const readFile = file => {
    return new Promise(function (resolve, reject) {
      let fr = new FileReader()

      fr.onload = function () {
        resolve(fr.result)
      }

      fr.onerror = function () {
        reject(fr)
      }

      fr.readAsBinaryString(file)
    })
  }

  const onSelectFile = e => {
    const fileNamesElement = document.getElementById('subir')
    const filesInp = files.fileInput?.current?.files
    const MAX_SIZE = 1 * 1024 * 1024 // 1MB en bytes

    if (filesInp?.length > 0) {
      // Calcular el peso total de los archivos seleccionados
      const totalSize = Array.from(filesInp).reduce((sum, file) => sum + file.size, 0)
      if (totalSize > MAX_SIZE) {
        dispatch(createMessage(i18n.t('expedientes.expsmsup'), 'error'))
        fileNamesElement.textContent = '' // Limpiar la lista de archivos mostrados
        e.value = ''
        setFiles({ ...files, filesAux: [] })
        return
      }

      setFiles({ ...files, filesAux: filesInp })
      const fileNames = Array.from(filesInp).map(file => file.name)
      fileNamesElement.textContent = fileNames.join(', ')
    } else {
      fileNamesElement.textContent = '' // Borrar el contenido si no se seleccionaron archivos
      e.value = ''
      setFiles({ ...files, filesAux: [] })
    }
  }

  const handleCheckBoxChange = event => {
    const { name, checked } = event.target
    setValores({
      ...valores,
      [name]: checked,
    })
  }

  const handleInputChange = event => {
    const { name, value } = event.target
    setValores({
      ...valores,
      [name]: value,
    })
  }

  const handleSelectChange = e => {
    setValores({
      ...valores,
      [e.name]: e.value,
    })
  }

  const handleSelectIdiomaChange = e => {
    setValores({
      ...valores,
      ['idioma_cliente']: e.value,
    })
  }

  const handleSelectPaisChange = e => {
    setValores({
      ...valores,
      ['pais']: e.value,
    })
  }

  const handleSelectCargo1Change = e => {
    setValores({
      ...valores,
      ['cargo1']: e.value,
    })
  }

  const handleSelectCargo2Change = e => {
    setValores({
      ...valores,
      ['cargo2']: e.value,
    })
  }

  const handleSelectPaisEnvioChange = e => {
    setValores({
      ...valores,
      ['pais_envio']: e.value,
    })
  }

  const handleSelectProvinciaChange = e => {
    setValores({
      ...valores,
      ['provincia']: e.value,
    })
  }

  const handleSelectProvinciaEnvioChange = e => {
    setValores({
      ...valores,
      ['provincia_envio']: e.value,
    })
  }

  const handleForm = event => {
    event.preventDefault()
    console.log(valores)

    let altaCliente = {
      tipo_expediente: 'ALTA_CLIENTE',
      descripcion_expediente1: valores.razon_social,
      itema001: valores.tipo_empresa,
      itema002: valores.canti_empresa,
      itema003: valores.razon_social,
      itema004: valores.nif,
      itema005: valores.contacto_empresa,
      itema006: valores.direccion,
      itema007: valores.poblacion,
      itema008: valores.codigo_postal,
      itema009: valores.provincia,
      itema010: valores.pais,
      itema011: valores.direccion_envio,
      itema012: valores.poblacion_envio,
      itema013: valores.codigo_postal_envio,
      itema014: valores.provincia_envio,
      itema015: valores.pais_envio,
      itema016: valores.telefono,
      itema017: valores.telefono2,
      itema018: valores.movil,
      itema019: valores.contacto,
      itema020: valores.movil2,
      itema021: valores.contacto2,
      itema022: valores.email2,
      itema023: valores.email1,
      itema024: valores.web,
      itema025: valores.banco,
      itema026:
        valores.iban + valores.num1 + valores.num2 + valores.num3 + valores.num4 + valores.num5,
      itema027: valores.forma_pago,
      itema028: valores.recargo,
      itema029: valores.horario_entrega,
      itema032: valores.cargo1,
      itema033: valores.cargo2,
      itema034: valores.email_facturas,
      reservado_check01: valores.usar_dir_fiscal ? 'S' : 'N',
      reservado_check02: valores.contrareembolso,
      reservado_check03: valores.promotions ? 'S' : 'N',
      comentarios: valores.observaciones,
      codigo_estad4: valores.idioma_cliente,
    }

    let readers = []
    let fileArray = []

    if (files.filesAux) {
      for (let index = 0; index < files.filesAux?.length; index++) {
        let selectedFile = files.filesAux?.item(index)
        if (selectedFile) {
          readers.push(readFile(selectedFile))
        }
      }
      Promise.all(readers).then(values => {
        for (let index = 0; index < files.filesAux.length; index++) {
          let selectedFile = files.filesAux.item(index)
          if (selectedFile) {
            let fileName = selectedFile?.name
            let fileType = selectedFile?.type
            let contenido = btoa(values[index])
            fileArray.push({
              nombre: fileName,
              tipo: fileType,
              contenido: contenido,
            })
          }
        }

        altaCliente['ficheros'] = fileArray?.length > 0 ? fileArray : []

        //Convertimos las keys a minusculas para evitar problemas en el back
        let val_aux = Object.keys(altaCliente)
        val_aux.map(valor => {
          let val_aux_Upper = valor // Nombre campo original (Puede estar en mayusculas)
          let val_aux_Lower = val_aux_Upper.toLowerCase() // Nombre campo minusculas
          if (val_aux_Upper !== val_aux_Lower) {
            Object.defineProperty(
              altaCliente,
              val_aux_Lower,
              Object.getOwnPropertyDescriptor(altaCliente, val_aux_Upper),
            )
            delete altaCliente[val_aux_Upper]
          }
          return altaCliente
        })
        //Enviamos datos
        dispatch(nuevoExpediente(altaCliente))
        // Limpiamos estado local
        setValores({
          tipo_empresa: '',
          canti_empresa: '',
          razon_social: '',
          nif: '',
          contacto_empresa: '',
          subir: '',
          direccion: '',
          poblacion: '',
          codigo_postal: '',
          provincia: '',
          pais: '',
          usar_dir_fiscal: false,
          direccion_envio: '',
          poblacion_envio: '',
          codigo_postal_envio: '',
          provincia_envio: '',
          pais_envio: '',
          horario_entrega: '',
          contacto: '',
          contacto2: '',
          telefono: '',
          telefono2: '',
          movil: '',
          movil2: '',
          email1: '',
          email2: '',
          email_facturas: '',
          web: '',
          banco: '',
          forma_pago_general: '',
          forma_pago: '',
          iban: 'ES',
          num1: '',
          num2: '',
          num3: '',
          num4: '',
          num5: '',
          contrareembolso: 'S',
          recargo: '',
          observaciones: '',
          cargo1: '',
          cargo2: '',
          promotions: false,
          idioma_cliente: '',
        })
        //Limpiamos datos ficheros
        setFiles({ filesAux: [], fileInput: React.createRef() })
      })
    }
  }

  if (isLoading) {
    return <Spinner showSpinner={true} />
  } else {
    return (
      <form
        className='container'
        onSubmit={handleForm}>
        <div className='titulo text-center p-3'>
          <h2>{i18n.t('altaCliente.titalcli')}</h2>
        </div>
        <h5>
          {i18n.t('altaCliente.desacli1')} <strong>Industrias Oriol</strong>{' '}
          {i18n.t('altaCliente.desacli2')}
        </h5>
        <h6>{i18n.t('general.titdtemp')}</h6>
        <div className='row'>
          <div className='col mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='razon_social'>
              {i18n.t('usuarios.urazsoc')}*:
            </label>
            <input
              id='razon_social'
              name='razon_social'
              value={valores.razon_social}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>

          <div className='col mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='nif'>
              {i18n.t('general.dnicif')}*:
            </label>
            <input
              id='nif'
              name='nif'
              type='text'
              maxLength='50'
              value={valores.nif}
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='contacto_empresa'>
            {i18n.t('general.etcontac')}*:
          </label>
          <input
            id='contacto_empresa'
            name='contacto_empresa'
            value={valores.contacto_empresa}
            type='text'
            maxLength='50'
            className='form-control'
            onChange={handleInputChange}
            required={true}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='idioma_cliente'>
            {i18n.t('general.idioma')}*:
          </label>
          <Select
            className='form-select'
            id={'idioma_cliente'}
            required={true}
            defaultValue={valores.idioma_cliente}
            options={optionsIdiomas}
            onChange={handleSelectIdiomaChange}
          />
        </div>

        <div className='row mb-3'>
          <div className='col'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='tipo_empresa'>
              {i18n.t('general.ettipemp')}*:
            </label>
            <Select
              className='form-select'
              id={'tipo_empresa'}
              required={true}
              defaultValue={valores.tipo_empresa}
              options={optionsTipoEmpresa}
              onChange={handleSelectChange}
            />
          </div>
        </div>

        <div className='row mb-5'>
          <div className='col'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='canti_empresa'>
              {i18n.t('general.etnumtra')}*:
            </label>
            <Select
              className='form-select'
              id={'canti_empresa'}
              required={true}
              defaultValue={valores.canti_empresa}
              options={optionsCantiEmpresa}
              onChange={handleSelectChange}
            />
          </div>
        </div>

        <h6>{i18n.t('general.titdocs')}</h6>
        <div className='form-group mb-5'>
          <label className='form-control-label px-3 font-weight-bold'>
            {i18n.t('altaCliente.etdocadj')}{' '}
            <a
              href='https://proveswebclient.ioriol.com/assets/img/036.pdf'
              download='036.pdf'>
              036
            </a>{' '}
            {i18n.t('general.odisyunc')}{' '}
            <a
              href='https://proveswebclient.ioriol.com/assets/img/037.pdf'
              download='037.pdf'>
              037
            </a>
            {' ('}
            {i18n.t('general.completo').toUpperCase()}
            {'- Max 1MB ) '}*:
          </label>
          <input
            id='subir'
            ref={files.fileInput}
            name='subir'
            accept='application/pdf'
            multiple={false}
            type='file'
            className='form-control'
            onChange={ev => {
              onSelectFile(ev.nativeEvent.target)
            }}
            required={true}
          />
        </div>

        <h6>{i18n.t('general.titdirfi')}</h6>
        <div className='row mb-3'>
          <div className='col-12 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='direccion'>
              {i18n.t('usuarios.udir')}*:
            </label>
            <input
              id='direccion'
              name='direccion'
              value={valores.direccion}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='pais'>
              {i18n.t('general.etpais')}*:
            </label>
            <Select
              className='form-select'
              id={'pais'}
              required={true}
              value={optionsEstados.find(e => e.value === valores.pais) || valores.pais}
              options={optionsEstados}
              onChange={handleSelectPaisChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='provincia'>
              {i18n.t('usuarios.uprov')}*:
            </label>
            <Select
              className='form-select'
              id={'provincia'}
              required={true}
              value={
                optionsProvincias.find(e => e.value === valores.provincia) || valores.provincia
              }
              options={optionsProvincias}
              onChange={handleSelectProvinciaChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='poblacion'>
              {i18n.t('general.etpobl')}*:
            </label>
            <input
              id='poblacion'
              name='poblacion'
              value={valores.poblacion}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='codigo_postal'>
              {i18n.t('usuarios.ucodpos')}*:
            </label>
            <input
              id='codigo_postal'
              name='codigo_postal'
              value={valores.codigo_postal}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-8 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='email_facturas'>
              {i18n.t('common.emailfac')}*:
            </label>
            <input
              id='email_facturas'
              name='email_facturas'
              value={valores.email_facturas}
              type='text'
              maxLength='50'
              pattern='^(?!.*\.\.)[a-zA-Z0-9._+\-%]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
        </div>

        <h6>{i18n.t('general.titenv')}</h6>
        <div className='px-3 mb-3'>
          <div className='form-check'>
            <input
              id='usar_dir_fiscal'
              name='usar_dir_fiscal'
              type='checkbox'
              checked={valores.usar_dir_fiscal}
              className={
                valores.usar_dir_fiscal ? 'form-check-input checked' : 'form-check-input unchecked'
              }
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label'
              htmlFor='usar_dir_fiscal'>
              {i18n.t('altaCliente.etdirfis')}
            </label>
          </div>
        </div>

        <div
          className='row mb-3'
          hidden={valores.usar_dir_fiscal}>
          <div className='col-12 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='direccion_envio'>
              {i18n.t('usuarios.udir')}:
            </label>
            <input
              id='direccion_envio'
              name='direccion_envio'
              value={valores.direccion_envio}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='pais_envio'>
              {i18n.t('general.etpais')}:
            </label>
            <Select
              className='form-select'
              id={'pais_envio'}
              defaultValue={
                optionsEstados.find(e => e.value === valores.pais_envio) || valores.pais_envio
              }
              options={optionsEstados}
              onChange={handleSelectPaisEnvioChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='provincia_envio'>
              {i18n.t('usuarios.uprov')}:
            </label>
            <Select
              className='form-select'
              id={'provincia_envio'}
              value={
                optionsProvinciasEnvio.find(e => e.value === valores.provincia_envio) ||
                valores.provincia_envio
              }
              options={optionsProvinciasEnvio}
              onChange={handleSelectProvinciaEnvioChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='poblacion_envio'>
              {i18n.t('general.etpobl')}:
            </label>
            <input
              id='poblacion_envio'
              name='poblacion_envio'
              value={valores.poblacion_envio}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='codigo_postal_envio'>
              {i18n.t('usuarios.ucodpos')}:
            </label>
            <input
              id='codigo_postal_envio'
              name='codigo_postal_envio'
              value={valores.codigo_postal_envio}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className='row mb-5'>
          <div className='col-2'>
            <label
              className='form-control-label px-3'
              htmlFor='horario_entrega'>
              {i18n.t('general.ethorent')}:
            </label>
            <input
              id='horario_entrega'
              name='horario_entrega'
              value={valores.horario_entrega}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
        </div>

        <h6>{i18n.t('altaCliente.titconta')}</h6>
        <div className='row mb-3'>
          <div className='col-6'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='contacto'>
              {i18n.t('general.etnomcon')} 1*:
            </label>
            <input
              id='contacto'
              name='contacto'
              value={valores.contacto}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3'
              htmlFor='telefono'>
              {i18n.t('usuarios.utel')} 1:
            </label>
            <input
              id='telefono'
              name='telefono'
              value={valores.telefono}
              type='text'
              maxLength='50'
              pattern='^\d{1,50}$'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='movil'>
              {i18n.t('general.etmovil')} 1*:
            </label>
            <input
              id='movil'
              name='movil'
              value={valores.movil}
              type='text'
              maxLength='50'
              pattern='^\d{1,50}$'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
              required={true}
            />
          </div>
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='email1'>
            {i18n.t('common.cemail')} 1*:
          </label>
          <input
            id='email1'
            name='email1'
            value={valores.email1}
            type='text'
            maxLength='50'
            pattern='^(?!.*\.\.)[a-zA-Z0-9._+\-%]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$'
            className='form-control'
            onChange={handleInputChange}
            required={true}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='cargo1'>
            {i18n.t('general.etcargo')} 1*:
          </label>
          <Select
            className='form-select'
            id={'cargo1'}
            required={true}
            defaultValue={valores.cargo1}
            options={optionsCargo}
            onChange={handleSelectCargo1Change}
          />
        </div>

        <div className='row mb-3'>
          <div className='col-6'>
            <label
              className='form-control-label px-3'
              htmlFor='contacto2'>
              {i18n.t('general.etnomcon')} 2:
            </label>
            <input
              id='contacto2'
              name='contacto2'
              value={valores.contacto2}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3'
              htmlFor='telefono2'>
              {i18n.t('usuarios.utel')} 2:
            </label>
            <input
              id='telefono2'
              name='telefono2'
              value={valores.telefono2}
              type='text'
              maxLength='50'
              pattern='^\d{1,50}$'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3'
              htmlFor='movil2'>
              {i18n.t('general.etmovil')} 2:
            </label>
            <input
              id='movil2'
              name='movil2'
              value={valores.movil2}
              type='text'
              maxLength='50'
              pattern='^\d{1,50}$'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3'
            htmlFor='email2'>
            {i18n.t('common.cemail')} 2:
          </label>
          <input
            id='email2'
            name='email2'
            value={valores.email2}
            type='text'
            maxLength='50'
            pattern='^(?!.*\.\.)[a-zA-Z0-9._+\-%]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$'
            className='form-control'
            onChange={handleInputChange}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3'
            htmlFor='cargo2'>
            {i18n.t('general.etcargo')} 2:
          </label>
          <Select
            className='form-select'
            id={'cargo2'}
            required={false}
            defaultValue={valores.cargo2}
            options={optionsCargo}
            onChange={handleSelectCargo2Change}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3'
            htmlFor='web'>
            {i18n.t('general.etpagweb')}:
          </label>
          <input
            id='web'
            name='web'
            value={valores.web}
            type='text'
            maxLength='50'
            className='form-control'
            onChange={handleInputChange}
          />
        </div>
        <p className='mb-5'>
          <b>{i18n.t('altaCliente.mjenvfac')}</b>
        </p>

        {/* ¿Es necesario?
		<div className="row px-4 mb-2">
			<label className="form-check-label">Datos bancarios</label>
			<input className="form-check-input" type="radio" name="forma_pago_general" id="forma_pago_general" value={valores.forma_pago_general}  />
		</div>
		*/}

        <h6>{i18n.t('general.ttforpag')}</h6>
        <div className='row mb-3'>
          <div className='col-12 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='banco'>
              {i18n.t('general.etbanco')}*:
            </label>
            <input
              id='banco'
              name='banco'
              value={valores.banco}
              type='text'
              maxLength='50'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <label
            className='form-control-label px-4 font-weight-bold'
            htmlFor='iban'>
            {i18n.t('altaCliente.iban')}*:
          </label>
          <div className='w-100 d-block d-lg-none'></div>
          <div className='col-lg-1 col-md-2 col-sm-4 col-4 mb-2'>
            <input
              id='iban'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='iban'
              value={valores.iban}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-lg-1 col-md-2 col-sm-4 col-4 mb-2'>
            <input
              id='num1'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num1'
              value={valores.num1}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-lg-1 col-md-2 col-sm-4 col-4 mb-2'>
            <input
              id='num2'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num2'
              value={valores.num2}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-lg-1 col-md-2 col-sm-4 col-4 mb-2'>
            <input
              id='num3'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num3'
              value={valores.num3}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-lg-1 col-md-2 col-sm-4 col-4 mb-2'>
            <input
              id='num4'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num4'
              value={valores.num4}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-lg-1 col-md-2 col-sm-4 col-4 mb-2'>
            <input
              id='num5'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num5'
              value={valores.num5}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className='form-check form-check-inline'>
          <label className='form-control-label px-3 font-weight-bold'>
            {i18n.t('general.etforpag')}*:
          </label>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='forma_pago'
              id='forma_pago_10'
              value='001'
              checked={valores.forma_pago === '001'}
              onChange={handleInputChange}
              required
            />
            <label
              className='form-check-label'
              htmlFor='forma_pago_10'>
              {i18n.t('altaCliente.girban10')}
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='forma_pago'
              id='forma_pago_30'
              value='002'
              checked={valores.forma_pago === '002'}
              onChange={handleInputChange}
            />
            <label
              className='form-check-label'
              htmlFor='forma_pago_30'>
              {i18n.t('altaCliente.girban30')}
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='forma_pago'
              id='forma_pago_60'
              value='003'
              checked={valores.forma_pago === '003'}
              onChange={handleInputChange}
            />
            <label
              className='form-check-label'
              htmlFor='forma_pago_60'>
              {i18n.t('altaCliente.girban60')}
            </label>
          </div>
        </div>
        <div className='form-group'>
          <div className='mb-3'>
            <p className='px-3'>** {i18n.t('altaCliente.mjclfcr1')}</p>
            <label
              className='form-control-label px-4'
              htmlFor='contrareembolso'>
              {i18n.t('altaCliente.mjclfcr2')}
            </label>
          </div>
          <div className='mb-3'>
            {/* <p className='px-3'>(Este tipo de pago no contará con ningún descuento)</p> */}
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='recargo'>
              {i18n.t('altaCliente.etregesp')}*:
            </label>
            <select
              id='recargo'
              name='recargo'
              required={true}
              className='form-control'
              onChange={handleInputChange}>
              <option value=''>{i18n.t('expedientes.exselna')}</option>
              <option value='S'>{i18n.t('general.si')}</option>
              <option value='N'>{i18n.t('general.no')}</option>
            </select>
          </div>
          <div className='form-group'>
            <label
              className='form-control-label px-3'
              htmlFor='observaciones'>
              {i18n.t('modal.obsrcns')}:
            </label>
            <textarea
              id='observaciones'
              name='observaciones'
              maxLength='4000'
              cols='1'
              className='form-control'
              onChange={handleInputChange}></textarea>
          </div>
          <p className='font-weight-bold mb-3'>{i18n.t('usuarios.ucamobli')}</p>

          <div className='form-check mb-3'>
            <input
              id='promotions'
              className='form-check-input m-1'
              name='promotions'
              type='checkbox'
              checked={valores.promotions}
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label px-4'
              htmlFor='promotions'>
              {i18n.t('altaCliente.okinfopn')}
            </label>
          </div>

          <div className='form-check mb-3'>
            <input
              id='condicions'
              className='form-check-input m-1'
              name='condicions'
              type='checkbox'
              required={true}
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label px-4 font-weight-bold'
              htmlFor='condicions'>
              {i18n.t('altaCliente.okprotdt')}
            </label>
          </div>

          <div className='form-check mb-3'>
            <input
              id='condicionscompra'
              className='form-check-input m-1'
              name='condicionscompra'
              type='checkbox'
              required={true}
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label px-4 font-weight-bold'
              htmlFor='condicionscompra'>
              {i18n.t('altaCliente.okvntin1')}{' '}
              <a
                href='/assets/img/oriol_condiciones_generales_de_venta.pdf'
                style={{ color: 'darkblue' }}
                target='_blank'>
                {i18n.t('altaCliente.okvntin2')}
              </a>{' '}
              {i18n.t('altaCliente.okvntin3')}
            </label>
          </div>
          <div id='form-group'>
            <p>
              {i18n.t('altaCliente.okcondt1')}
              {i18n.t('altaCliente.okcondt2')}
            </p>
          </div>
          <div className='row justify-content-center'>
            <div className='form-group col-sm-3 p-3'>
              <input
                id='enviar'
                className='btn btn-primary btn-block'
                value={i18n.t('usuarios.uenvi')}
                type='submit'
              />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default AltaCliente
